class Dashboard {
	constructor(instance) {
		this.axios = instance;
	}
	//관리자 대시보드 - 업무 현황
	async getProjectSituation(params) {
		const response = await this.axios.get(`/dashboard/admin/project-situation`, {params})
		return response.data;
	}
	//관리자 대시보드 - 매출 현황
	async getAmountSituation(params) {
		const response = await this.axios.get(`/dashboard/admin/amount-situation`, {params})
		return response.data;
	}
	//이슈보드 목록 조회 (필터 포함)
	async getIssue(params) {
		const response = await this.axios.get(`/dashboard/issue/list`, {params})
		return response.data;
	}
	//이슈보드 업무 목록 가져오기
	async getIssueProject(params) {
		const response = await this.axios.get(`/dashboard/issue/project/list`, {params})
		return response.data;
	}
	//이슈보드 작성하기 (category 포함)
	async addIssue(body) {
		// body: { projectId, content, category }
		const response = await this.axios.put(`/dashboard/issue`, body)
		return response.data;
	}
	//이슈보드 수정하기
	async editIssue(body) {
		const response = await this.axios.patch(`/dashboard/issue/${body.id}`, body)
		return response.data;
	}
	//이슈보드 글 수정 (오직 상태)
	async updateIssueStatus(id, status) {
		const response = await this.axios.patch(`/dashboard/issue/${id}/status`, {status: status})
		return response.data
	}
	//이슈보드 글 삭제
	async deleteIssue(id) {
		const response = await this.axios.delete(`/dashboard/issue/${id}`)
		return response.data
	}
}

export default Dashboard